import React, { Suspense, lazy } from 'react';
import PageSkeleton from 'Components/DesignSystem/PageSkeleton/PageSkeleton';

const AnalyticsDetailProvider = lazy(() => import('./AnalyticsDetailProvider'));

const AnalyticsDetailProviderLazy = (props: any) => (
  <Suspense fallback={<PageSkeleton preset="detail" label="Loading metric" data-testid="analytics-detail-lazy-loading" />}>
    <AnalyticsDetailProvider {...props} />
  </Suspense>
);

export default AnalyticsDetailProviderLazy;
